import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import IWF from '../components/image-with-fallback'
import { useState, useEffect } from 'react'
import { useGlobal } from 'reactn'
import posed, { PoseGroup } from 'react-pose'
import { setConfig } from 'react-hot-loader'
import { tween } from 'popmotion'
import { interpolate } from 'flubber'

import './nav.css'
import './layout.css'

setConfig({ pureSFC: true });

// animation 

const Modal = posed.div({
  enter: {
    opacity: 1,
    transition: {
      default: { duration: 300 }
    }
  },
  exit: {
    opacity: 0,
    transition: { duration: 500 }
  }
})

const ModalContent = posed.div({
  enter: {
    opacity: 1,
    // delay: 100,
    transition: {
      default: { duration: 500 }
    }
  },
  exit: {
    opacity: 0,
    transition: { duration: 500 }
  }
})

const OnDemand = posed.h3({
  enter: {
    opacity: 1,
    delay: 100,
    y: -100,
    transition: {
      default: { duration: 500 }
    }
  },
  exit: {
    opacity: 0,
    transition: { duration: 300 }
  }
  
})

const Management = posed.div({
  enter: {
    opacity: 1,
    delay: 400,
    y: -100,
    transition: {
      default: { duration: 500 }
    }
  },
  exit: {
    opacity: 0,
    transition: { duration: 300 }
  }
})

const Development = posed.div({
  enter: {
    opacity: 1,
    delay: 450,
    y: -100,
    transition: {
      default: { duration: 500 }
    }
  },
  exit: {
    opacity: 0,
    transition: { duration: 300 }
  }
})

const Marketing = posed.div({
  enter: {
    opacity: 1,
    delay: 500,
    y: -100,
    transition: {
      default: { duration: 500 }
    }
  },
  exit: {
    opacity: 0,
    transition: { duration: 300 }
  }
})

const OurMission = posed.div({
  enter: {
    opacity: 1,
    delay: 550,
    y: -100,
    transition: {
      default: { duration: 500 }
    }
  },
  exit: {
    opacity: 0,
    transition: { duration: 300 }
  }
})

const ContactUs = posed.div({
  enter: {
    opacity: 1,
    delay: 600,
    y: -100,
    transition: {
      default: { duration: 500 }
    }
  },
  exit: {
    opacity: 0,
    transition: { duration: 300 }
  }
})

// component

const Nav = (props) => {

  // global state

  const [showConnectModal, setShowConnectModal] = useGlobal('showConnectModal')

  // local state

  const [isVisible, setVisibility] = useState(false)

  useEffect(() => {
    if (typeof document !== 'undefined') {
      if(isVisible === true) {
        document.body.style.overflow = "hidden"
        document.ontouchmove = function (e) {
          e.preventDefault();
        }
      }
      else { 
        document.body.style.overflow = "visible"
        document.ontouchmove = function (e) {
          return true;
        }
      }
    }
  }, [isVisible])

  const navBar = () => {
    
    const chooseMobileLogo = (location) => {
      if(((location === 'contact') || (location === 'success'))  && isVisible === false) return 'cs-wordmark-black'
      return 'cs-wordmark-white'
    } 

    const checkForContact = (location) => {
      if(((location === 'contact') || (location === 'success')) && isVisible === false) return "contact-hamburger"
      return "Hamburger-Icon"
    } 

    let menuChoice = 
      <li className="hamburger-li all-link">
      <svg width="24px" height="14px" viewBox="0 0 24 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <title>Group</title>
          <g id="sales.createsafe.io" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(-48.000000, -28.000000)" id="Group">
                  <g transform="translate(36.000000, 11.000000)">
                      <rect id="Rectangle" x="0" y="0" width="48" height="48"></rect>
                      <g id={checkForContact(props.location)} transform="translate(12.000000, 18.000000)" fill-rule="nonzero" stroke='black' stroke-width="2">
                        <path d="M0,11.5 L24,11.5" id="Line"></path>
                        <path d="M0,0.5 L24,0.5" id="Line"></path>
                      </g>
                  </g>
              </g>
          </g>
        </svg>
      </li>

    if (isVisible === true) {
      menuChoice = 
        <li className="hamburger-li">
          <IWF fileName="menu-x" className="menu-x"/>
        </li>
    }

    return (
      <div className="nav">
        <div className="nav-left">
          <div onClick={() => { 
            setVisibility(!isVisible)
            }}
          >
            {menuChoice}
          </div>
        </div>
        <div className="nav-center">
        <a href='https://createsafe.io'>
          <IWF fileName="cs-wordmark-black" className="nav-logo-desktop all-link" />
          <IWF className="nav-logo-mobile all-link" fileName={chooseMobileLogo(props.location)}/>
        </a>
        </div>
        <div className="nav-right">
          <a href='https://createsafe.io/our-mission' className="nav-contact-us cta">OUR MISSION</a>
          <span onClick={() => setShowConnectModal(true)} className="nav-contact-us cta" >CONNECT NOW</span>
        </div>
      </div>  
    )
  }

  return (    
    <div style={{display: 'flex', flexDirection: 'column'}}>    
      <PoseGroup>
        {isVisible && 
        <Modal key="modal" className="modal-menu">
          {navBar()}
          <ModalContent className="modal-main-container">
            {/* <div className="on-demand-container"> */}
              <OnDemand className="modal-on-demand">
                <Link to="/" className="white" >ARTIST SERVICES</Link>
              </OnDemand>
            {/* </div> */}
            {/* <div className="modal-services-container"> */}
              <Management>
                <Link to="/management/" className="all-link modal-management modal-services" onClick={() => {
                  if(isVisible === true && props.location === 'management') setVisibility(false)
                }}>
                  <span className="modal-development modal-services">ARTIST MANAGEMENT</span>
                </Link>                
              </Management>
              <Development>
                <Link to="/development/" className="all-link" onClick={() => {
                  if(isVisible === true && props.location === 'development') setVisibility(false)
                }}>
                  <span className="modal-development modal-services">ARTIST DEVELOPMENT</span>
                </Link>
              </Development>
              <Marketing>
                <Link to="/marketing/" className="all-link modal-marketing modal-services" onClick={() => {
                  if(isVisible === true && props.location === 'marketing') setVisibility(false)
                }}>
                  <span className="modal-development modal-services">ARTIST MARKETING</span>
                </Link>
              </Marketing>              
              <OurMission>
                <a href="https://www.createsafe.io/our-mission" className="all-link modal-services">OUR MISSION</a>
              </OurMission>
              <div>
                <ContactUs onClick={() => setShowConnectModal(true)} className="modal-get-started cta">CONNECT NOW</ContactUs>
              </div> 
          </ModalContent>   
        </Modal>
        }
      </PoseGroup>
      {navBar()}
    </div>
   
    )
  }



Nav.propTypes = {
  siteTitle: PropTypes.string,
}

Nav.defaultProps = {
  siteTitle: ``,
}

export default Nav
